export const hobbiesActionTypes = {
    ADD_HOBBY: "ADD_HOBBY",
    REMOVE_HOBBY: "REMOVE_HOBBY",
    CHANGE_HOBBY: "CHANGE_HOBBY",
    MOVE_HOBBY_UP: "MOVE_HOBBY_UP",
    MOVE_HOBBY_DOWN: "MOVE_HOBBY_DOWN",
}

export function hobbiesReducer( hobbies, action ) {
    let updatedHobbies = [ ...hobbies ];
    let numberOfHobbies = hobbies.length;
    let currentOrder = action.item.order;

    switch ( action.type ) {
        case hobbiesActionTypes.ADD_HOBBY:
            updatedHobbies.push(
                {
                    order: numberOfHobbies++,
                    text: action.item.text,
                }
            );
            break;

        case hobbiesActionTypes.REMOVE_HOBBY:
            updatedHobbies = hobbies
                .filter( hobby => hobby.order !== action.item.order )
                .sort( ( a, b ) => a.order - b.order )
                .map( ( hobby, index ) => {
                    hobby.order = index;
                    return hobby;
                } );
            break

        case hobbiesActionTypes.CHANGE_HOBBY:
            updatedHobbies = hobbies
                .map( hobby => {
                        if ( hobby.order === action.item.order ) {
                            return action.item
                        } else {
                            return hobby
                        }
                    }
                )
            break;

        case hobbiesActionTypes.MOVE_HOBBY_UP:
            updatedHobbies = hobbies
                .map( hobby => {
                    if ( hobby.order === action.item.order ) {
                        hobby.order--;
                    } else if ( hobby.order === action.item.order - 1 ) {
                        hobby.order++;
                    }
                    return hobby
                } );
            break;

        case hobbiesActionTypes.MOVE_HOBBY_DOWN:
            updatedHobbies = hobbies
                .map( hobby => {
                    if ( hobby.order === currentOrder ) {
                        hobby.order++;
                    } else if ( hobby.order === currentOrder + 1 ) {
                        hobby.order--;
                    }
                    return hobby
                } );
            break;

        default: {
            throw new Error( `Unknown action: [${ action.type }]` );
        }
    }
    return updatedHobbies.sort( ( a, b ) => a.order - b.order );
}

